<template>
  <div>
    <b-table
      :items="participations"
      :fields="fields"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
    >

      <template v-slot:cell(planItem.applyActivity.validator)="row">

        <v-select
            :options="trainers"
            :getOptionLabel="l => `${l.surName} ${l.firstName}`"
            v-model="row.item.planItem.applyActivity.memberValidator"
            class="bg-white rounded"
            :appendToBody="true"
        >
          <template #option="{ surName, firstName }">
            {{ surName }} {{ firstName }}
          </template>
        </v-select>


      </template>


      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="assignValidator(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('applyActivity.assignValidator')"
        >
          <b-icon icon="box-arrow-in-right"></b-icon>
        </b-button>

        <b-button
            size="sm"
            @click="goToEvaluation(row)"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('applyActivity.goTo')"
        >
          <b-icon icon="eye"></b-icon>
        </b-button>

      </template>

      <template v-slot:empty="">
        <h6>{{ $t("applyActivity.emptyApplyActivitiesTable") }}</h6>
      </template>
    </b-table>
  </div>
</template>

<script>
import trainingService from "@/services/training.service";
import {makeErrorToast, makeToast} from "@/services/error.service";

export default {
  props: {
    activity: {
      type: Object
    }
  },
  mounted() {
    this.getActivityParticipants();
    this.getActiveLeaders();
  },
  data() {
    return {
      fields: [
        { key: "member.id", label: "Α.Μ.", sortable: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "member", label: "Ονοματεπώνυμο", sortable: true, sortByFormatted: true, filterByFormatted: true, formatter: "formatFullName", thClass: 'text-left', tdClass: 'text-left'},
        { key: "member.cinfo.email", label: "e-mail", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "planItem.applyActivity.validator", label: "Παραστάτης", sortable: false, },
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      participations: [],
      trainers: []
    }
  },
  methods: {
    formatId(leader) {
      return leader.position != 'ASSOCIATE' ? (leader.member.id) : '-';
    },
    formatTrainerFullName(leader) {
      return leader.position != 'ASSOCIATE' ? (leader.member.surName +" " + leader.member.firstName) : leader.associateName ;
    },
    formatFullName(member) {
      return member.surName +" " + member.firstName;
    },
    translatePosition(position) {
      return this.$t('trainingLeadersEnums.'+ position);
    },
    translateLeaderType(type) {
      return this.$t('training-view.' + type);
    },
    translatePartTime(partTime) {
      return this.$t('training-view.partTime.'+ partTime);
    },
    cancelSearch () {
      if (this.cancelSource) {
        this.cancelSource.cancel('cancel');
      }
    },
    getActivityParticipants() {
      this.loading = true;
      trainingService.getActivitysParticipations(this.activity.id).then(
          (response) => {
            this.participations = response.data;
            this.loading = false;
          },
          (error) => {
            makeErrorToast(this.$bvToast, error);
          }
      )
    },
    assignValidator(row) {
      console.log()
      trainingService.assignApplyActivity(row.item.planItem.applyActivity.id, row.item.planItem.applyActivity.memberValidator).then(
          (response) => {
            row.item.planItem.applyActivity = response.data;
            makeToast(this.$bvToast,"Επιτυχής ανάθεση παραστάτη")
          }, (error) => {
            makeErrorToast(this.$bvToast, error);
          }
      );
    },
    getActiveLeaders() {
      trainingService.getActivityLeaders(this.activity.id).then(
          (response) => {
            this.trainers = [...new Set(response.data.filter(l=>l.member).map(item => item.member))];
          }, (error) => {
            makeErrorToast(this.$bvToast, error);
          }
      );
    },
    goToEvaluation(activity) {
      window.location.href = `/app/training/web/apply-activities/${activity.item.planItem.applyActivity.id}`;
    },
  }
}
</script>